import { Component, Input, Output } from 'angular-ts-decorators';
import { CustomizerFilter, FilterOption } from '../../../models';
import { IHeroCustomizerV3FilterComponent } from '../../models/hero-customizer-v3.filter.component';

import template from './hero-customizer-v3-filter-checkbox.component.html';

@Component({
  selector: 'heroCustomizerV3FilterCheckbox',
  template,
})
export class HeroCustomizerV3FilterCheckboxComponent implements IHeroCustomizerV3FilterComponent {
  public static $inject: ReadonlyArray<string> = [];

  @Input() public filter?: CustomizerFilter;

  @Output() public onFilterChange?: ({ filter: CustomizerFilter }) => void;

  public onOptionClicked(option: FilterOption) {
    option.checked = !option.checked;
    if (this.onFilterChange) {
      this.onFilterChange({ filter: this.filter });
    }
  }
}
